/**
 * Created by andrey on 01.08.2022
 */

HideAnimations = function (f) {
    const game = Game.currentGame;

    if (game.outcome !== GameBase.OUTCOME_LOST) {
        cleverapps.focusManager.hideControlsWhileFocused("MenuBarGoldItem");
    }

    const bonusLevelView = cleverapps.Scenes.GetSceneComponent(WordGameSceneComponent).bonusLevelView;
    const items = [game.keypad, game.board, bonusLevelView, this.scoreBarView].filter(Boolean);

    f = cleverapps.wait(items.length, f);
    items.forEach((item) => {
        item.hide(f);
    });
};